export class Reduzierungsarten {
    public einspeisereduzierung: boolean = false;
    public lastreduzierung: boolean = false;
}
